import Label from "lib/Label";
import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import "./index.scss";
import { PopoverComponent } from "lib";
import { getDependentsNames } from "helper";
const ActionCard = (props) => {
  const { title, input_fields, onClick, flags } = props;
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const isUserClicked = useSelector((state) => state?.usersReducer?.isClicked);
  // delete if you deleting the dependency of this variable
  // const wfActiveStep = useSelector((state) => state.userInfo?.primaryUser?.active_step)
  
  const workFlowConfig = useSelector(
    (state) => state.configurationReducer?.config?.wf_journey
  );
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const params = useParams();
  const dispatch = useDispatch()

  let primaryArray = primaryUser?.source_data?.subworkflows?.filter(
    (item) => item.workflow_type == "primary"
  );
  let coApplicant = primaryUser?.source_data?.subworkflows?.filter(
    (item) => item.workflow_type == "co-applicant"
  );
  let guardian = primaryUser?.source_data?.subworkflows?.filter(
    (item) => item.workflow_type == "guardian"
  );

  const renderCards = (item, index) => {
    let {
      is_verified,
      status,
      _id: subWfId,
      user_id,
      email,
      mobile_number: phone,
      profile_color_code,
      first_name,
      last_name,
      wf_active_step,
    } = item;
    let firstInitial = first_name ? first_name.trim().charAt(0) : ""
    let secondInitial = last_name ? last_name.trim().charAt(0) : "";
    let initials = firstInitial + secondInitial;
    let internalUser = JSON.parse(localStorage.getItem("userToken"));
    let showFlags = flags?.show == false ? false : true;
    const presentActiveModule = workFlowConfig?.filter(item=>{
      return item.step == wf_active_step
    })    

    if (internalUser?.length || isUserClicked) {
      is_verified = is_verified ? true : false;
    } else is_verified = is_verified ? is_verified : false;

    if (flags?.is_verified == "true") {
      is_verified = flags?.is_verified ? true : false
    } else is_verified = is_verified ? is_verified : false;

    const removeHTMLTAggs = (str) => {
      if (str === null || str === "") return false;
      else str = str.toString();
      return str.replace(/<[^>]*>/g, "");
    };

    return (
      <Fragment key={index}>
        <div

        // old code which is not proper
//           className={`
     
//              ${wfActiveStep === 1
//               ? is_verified
//                 ? "verified_container"
//                 : "pending_container"
//               : "completed_container"}
//               ${flags?.disabled && wfActiveStep && wfActiveStep > flags?.disabled ? "non_editable_container" : ""}
//               ${loggedUserId && status === flags?.disabled_card ? "non_editable_container" : ""}
// `
//           }

          className={`
     
             ${presentActiveModule[0]?.module_name == "Dynamic Forms"
              ? is_verified
                ? "verified_container"
                : "pending_container"
              : "completed_container"}
`
          }
          onClick={() =>
            onClick(
              primaryUser?._id,
              user_id,
              subWfId,
              is_verified,
              email,
              phone
            )
          }
        >
          {presentActiveModule[0]?.module_name == "Dynamic Forms" && showFlags ? (
            is_verified ? (
              <p className="status">Verified</p>
            ) : (
              <p className="status">Pending</p>
            )
          ) : (
            showFlags ? <p className="status">Complete</p> : ""
          )}
          <p className="image" style={{ backgroundColor: profile_color_code }}>
            {initials}
          </p>
          <div className="user_details">
            {input_fields.map((_item, _index) => {
              const { name: itemName } = _item;
              const result = item?.full_name?.length > 30 ? item?.full_name?.slice(0, 29) : item?.full_name
              return (
                <div key={_index} className=" preview_data_value_name">
                  {itemName == "full_name" ? (
                    item.hasOwnProperty("guardian_of") ? (
                      <p className="preview_data_value preview_data_value_name guardian_preview_with_dependents">
                        {item[itemName]} (Guardian of {getDependentsNames(item["guardian_of"], primaryUser.source_data?.subworkflows, itemName).map(name => name.split(" ")[1]).join(",")})
                      </p>
                    ) : (
                      <>
                        {itemName === "full_name" && <>{result} {item?.full_name?.length > 30 && <PopoverComponent
                          triggerWhen={["hover", "focus"]}
                          trigger={
                            itemName === "full_name" ? (
                              <span
                                style={{
                                  fontWeight: 'bold'
                                }}
                                className="cursor-pointer-more-text-1 ">
                                {`....`}
                              </span>
                            ) : ""
                          }
                          fullBodyPresent={true}
                          children={
                            <>
                              <div className="option_list shadow-sm rounded-0 border-0 px-1 mb-2 mx-0 bg-white ">
                                <button className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey" >
                                  {item?.full_name
                                    ? removeHTMLTAggs(item?.full_name)
                                    : " "}
                                </button>

                              </div>
                            </>
                          }
                        />}
                        </>}
                      </>
                    )
                  ) : (
                    <p className="preview_data_value">{item[itemName]}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Fragment>

    );
  };


  return (
    <>
      <Label label={title} className="title " />
      <Label label={"My Application"} className="title  mt-0" />
      {primaryArray?.map((item, index) => {
        return renderCards(item, index);
      })}

      {coApplicant && coApplicant.length == 1 ? (
        <>
          <Label label={"Co-applicant"} className="title mt-0" />
          {coApplicant?.map((item, index) => {
            return renderCards(item, index);
          })}
        </>
      ) : (
        ""
      )}
      {coApplicant && coApplicant.length > 1 ? (
        <>
          <Label label={"Co-applicants"} className="title mt-0" />
          {coApplicant?.map((item, index) => {
            return renderCards(item, index);
          })}
        </>
      ) : (
        ""
      )}

      {guardian && guardian.length ? (
        <>
          <Label label={"Guardian"} className="title  mt-0" />
          {guardian?.map((item, index) => {
            return renderCards(item, index);
          })}
        </>
      ) : (
        ""
      )}

    </>
  );
};

export default ActionCard;
